import { Injectable } from '@angular/core';
import { DWSTag, TagExpType, TagLang, TagService } from '../services/interfaces/tags';

@Injectable({
    providedIn: 'root'
})
export class TagsService {

    getAllServices(lang: 'it' | 'de' | 'en'): TagService[] {
        return services.map((x: any) => {
            let serviceName: string;
            // Handle new structure with name object
            if (x.name && typeof x.name === 'object' && 'nameIt' in x.name && 'nameEn' in x.name) {
                serviceName = lang === 'it' ? x.name.nameIt : x.name.nameEn;
            } else if (x.name_translations) {
                // Fallback to old structure
                serviceName = x.name_translations[lang];
            } else {
                serviceName = '';
            }
            
            // Create TagService compatible object
            return {
                id: x.id,
                name: serviceName,
                active: true,
                color: '#ffffff',
                code: x.code || '-',
                name_translations: {
                    it: typeof x.name === 'object' && 'nameIt' in x.name ? x.name.nameIt : serviceName,
                    en: typeof x.name === 'object' && 'nameEn' in x.name ? x.name.nameEn : serviceName,
                    de: serviceName
                },
                category_id: x.category_id || '',
                category_code: x.category_code || 'services',
                icon: x.icon
            } as TagService;
        })
    }

    getAllLang(lang: 'it' | 'de' | 'en'): TagLang[] {
        return langs.map(x => {
            x.name = x.name_translations[lang];
            return x as TagLang;
        })
    }

    getAllTypes(lang: 'it' | 'de' | 'en'): TagExpType[] {
        return types.filter(x => x.active).map(x => {
            x.name = x.name_translations[lang];
            return x as TagExpType;
        })
    }

    getCategoryCodeFromId(id: string): string {
        var langs = this.getAllLang('it').filter(x => { return x.category_id == id });
        if(langs.length > 0) return langs[0].category_code;
        var services = this.getAllServices('it').filter(x => {return x.category_id == id });
        if(services.length > 0) return services[0].category_code;
        var types = this.getAllTypes('it').filter(x => {return x.category_id == id });
        if(types.length > 0) return types[0].category_code;
        return '';
    }

    getTagFromId(id: string): DWSTag | undefined {
        var types = this.getAllTypes('it').filter(x => { return x.id == id });
        if(types.length > 0) return types[0];
        var langs = this.getAllLang('it').filter(x => { return x.id == id });
        if(langs.length > 0) return langs[0];
        var services = this.getAllServices('it').filter(x => { return x.id == id });
        if(services.length > 0) return services[0];
        console.log('Tag not found with id: ' + id);
        return undefined;
    }
}
const iconTypePrefix = "assets/icons/ESPERIENZE"
const iconServicePrefix = "assets/icons/Servizi_icone"

const types = [{
    "id": "7c43fcfe-47fc-4136-8beb-76c003f6b4db",
    "name": "eventi",
    "active": true,
    "color": "#e4d5a3",
    "code": "event",
    "name_translations": { "de": "Event", "en": "Event", "it": "Evento" },
    "category_id": "f7d85a2b-fec7-438b-b3b4-f1a4cc2413b6",
    "category_code": "exptype",
    "icon": "assets/icons/ESPERIENZE/Evento.svg"
},
{
    "id": "12171960-b2ec-417e-9541-73aed9cca24b",
    "name": "esperienze speciali",
    "active": false,
    "color": "#6f8a79",
    "code": "special",
    "name_translations": { "de": "Exklusive", "en": "Exclusive", "it": "Esclusiva" },
    "category_id": "f7d85a2b-fec7-438b-b3b4-f1a4cc2413b6",
    "category_code": "exptype",
    "icon": "assets/icons/ESPERIENZE/Tour_privato.svg"
},
{
    "id": "aea908cb-9ff3-435a-9327-28437a36ee54",
    "name": "esperienze con pernottamento",
    "color": "#173d4f",
    "active": true,
    "code": "stay",
    "name_translations": { "de": "Getaways", "en": "Getaways", "it": "Pernottamento " },
    "category_id": "f7d85a2b-fec7-438b-b3b4-f1a4cc2413b6",
    "category_code": "exptype",
    "icon": "assets/icons/ESPERIENZE/Pernottamento.svg"
},
{
    "id": "cbbc32c5-adf3-46c5-afb8-b08967b040e5",
    "name": null,
    "color": "#ffffff",
    "active": true,
    "code": "sport_adventure",
    "name_translations": { "de": "Sport & Adventure", "en": "Sport & Adventure", "it": "Sport & Avventura" },
    "category_id": "11725cd6-bb75-493a-b314-b33484804920",
    "category_code": "mood",
    "icon": "assets/icons/ESPERIENZE/Sport_&_Avventura.svg"
},
{
    "id": "b225184f-e307-4b06-aa62-602c6775a087",
    "name": null,
    "color": "#ffffff",
    "code": "food_addicted",
    "active": true,
    "name_translations": { "de": "Food addicted", "en": "Food addicted", "it": "Food addicted" },
    "category_id": "11725cd6-bb75-493a-b314-b33484804920",
    "category_code": "mood",
    "icon": "assets/icons/ESPERIENZE/Food_Addicted.svg"
},
{
    "id": "0517e62c-aad0-42af-9e6e-83f32f8a7255",
    "name": null,
    "color": "#ffffff",
    "code": "wine_lover",
    "active": true,
    "name_translations": { "de": "Wine Lover", "en": "Wine Lover", "it": "Wine Lover" },
    "category_id": "11725cd6-bb75-493a-b314-b33484804920",
    "category_code": "mood",
    "icon": "assets/icons/ESPERIENZE/Wine_Lover.svg"
},
{
    "id": "83ff1875-8cf7-4c17-8f21-0f5afb078fb8",
    "name": null,
    "color": "#ffffff",
    "code": "family",
    "active": true,
    "name_translations": { "de": "Family", "en": "Family", "it": "Famiglia" },
    "category_id": "11725cd6-bb75-493a-b314-b33484804920",
    "category_code": "mood",
    "icon": "assets/icons/ESPERIENZE/Famiglia.svg"
},
{
    "id": "56751c11-b292-4d1e-9ab1-6b0036a35d32",
    "name": null,
    "color": "#ffffff",
    "code": "history_culture",
    "active": true,
    "name_translations": { "de": "Geschichte & Kultur", "en": "History & Culture", "it": "Storia & Cultura" },
    "category_id": "11725cd6-bb75-493a-b314-b33484804920",
    "category_code": "mood",
    "icon": "assets/icons/ESPERIENZE/Storia_&_Cultura.svg"
},
{
    "id": "1c96303c-999e-4740-b24b-b31aec4ae5db",
    "name": null,
    "color": "#ffffff",
    "code": "romantic_choice",
    "active": true,
    "name_translations": { "de": "Romantische Wahl", "en": "Romantic choice", "it": "Scelta Romantica" },
    "category_id": "11725cd6-bb75-493a-b314-b33484804920",
    "category_code": "mood",
    "icon": "assets/icons/ESPERIENZE/Romantica.svg"
},
{
    "id": "391a796c-5ce6-4b45-8914-5b76079ad553",
    "name": null,
    "color": "#ffffff",
    "code": "relax_wellness",
    "active": true,
    "name_translations": { "de": "Entspannung & Wellness", "en": "Relax & Wellness", "it": "Relax & Wellness" },
    "category_id": "11725cd6-bb75-493a-b314-b33484804920",
    "category_code": "mood",
    "icon": "assets/icons/ESPERIENZE/Relax_&_Wellness.svg"
},

{
    "id": "606f8019-de3d-487d-9f5e-a8947aae22a6",
    "name": null,
    "color": "#bdbdbd",
    "code": "smart",
    "active": true,
    "name_translations": { "de": "Online", "en": "Online", "it": "Online" },
    "category_id": "f7d85a2b-fec7-438b-b3b4-f1a4cc2413b6",
    "category_code": "exptype",
    "icon": "assets/icons/ESPERIENZE/Online.svg"
},
{
    "id": "031d9ed7-31e6-40fb-b453-ca5fe76f8108",
    "name": "degustazioni",
    "color": "#ba3250",
    "code": "tasting",
    "active": true,
    "name_translations": { "de": "Weinprobe", "en": "Tasting", "it": "Degustazione" },
    "category_id": "f7d85a2b-fec7-438b-b3b4-f1a4cc2413b6",
    "category_code": "exptype",
    "icon": "assets/icons/ESPERIENZE/Degustazione_tradizionale.svg"
},
{
    "id": "4e8dcef2-7748-471b-be29-dba8ba8a97e8",
    "name": null,
    "color": "#ffffff",
    "code": "young_funny",
    "active": true,
    "name_translations": { "de": "Young & Fun", "en": "Young & Fun", "it": "Young & Fun" },
    "category_id": "11725cd6-bb75-493a-b314-b33484804920",
    "category_code": "mood",
    "icon": "assets/icons/ESPERIENZE/Young_&_Fun.svg"
}
];

const visit_reasons = [{
    "id": "3b5e203d-0aa6-42c0-a9a6-50c5572283f6",
    "name": null,
    "color": "#ffffff",
    "code": "-",
    "active": true,
    "name_translations": { "de": "Sport & Adventure", "en": "Sport & Adventure", "it": "Sport & Avventura" },
    "category_id": "67dc6974-562d-47df-a1a9-4a45ff7462ca",
    "category_code": "visit_reasons",
    "icon": "placeholder.png"
},
{
    "id": "50b9403a-c48a-46af-adfd-764a97d53bf8",
    "name": null,
    "color": "#ffffff",
    "code": "-",
    "active": true,
    "name_translations": { "de": "Leidenschaft für Wein", "en": "Passion for Wine", "it": "Passione per il Vino" },
    "category_id": "67dc6974-562d-47df-a1a9-4a45ff7462ca",
    "category_code": "visit_reasons",
    "icon": "Wine_Lover.svg"
},
{
    "id": "15970a8f-e273-4f5b-a41a-810eeba9a87b",
    "name": "Romantico",
    "color": "#ffffff",
    "active": false,
    "code": "-",
    "name_translations": { "de": "Vergnügung un Kultur", "en": "Pleasure and Culture", "it": "Piacere e Cultura" },
    "category_id": "67dc6974-562d-47df-a1a9-4a45ff7462ca",
    "category_code": "visit_reasons",
    "icon": "Storia_&_Cultura.svg"
}, {
    "id": "2359ce05-54dd-495c-92e4-e9f7dd199851",
    "name": null,
    "active": false,
    "color": "#ffffff",
    "code": "-",
    "name_translations": { "de": "Ich bin mir nicht sicher", "en": "I'm not sure why", "it": "Non saprei dire perchè" },
    "category_id": "67dc6974-562d-47df-a1a9-4a45ff7462ca",
    "category_code": "visit_reasons",
    "icon": "placeholder.png"
},
{
    "id": "3d6ea6ed-0421-4b7a-b611-9be9b89e0abd",
    "name": "Business",
    "color": "#ffffff",
    "active": false,
    "code": "-",
    "name_translations": { "de": "Business", "en": "Business", "it": "Motivi d'Affari" },
    "category_id": "67dc6974-562d-47df-a1a9-4a45ff7462ca",
    "category_code": "visit_reasons",
    "icon": "placeholder.png"
},
{
    "id": "3de28fd1-c2da-40bf-b6ac-e6e66da3e1db",
    "name": null,
    "active": true,
    "color": "#ffffff",
    "code": "-",
    "name_translations": { "de": "Eine romantische Wahl", "en": "A Romantic Choice", "it": "Una Scelta Romantica" },
    "category_id": "67dc6974-562d-47df-a1a9-4a45ff7462ca",
    "category_code": "visit_reasons",
    "icon": "Romantica.svg"
}];

const langs = [
    {
        "id": "39bbbde9-2294-4e04-9ab8-01e1d116ca67",
        "name": "Italiano",
        "color": "#ffffff",
        "code": "it",
        "name_translations": { "de": "Italienisch", "en": "Italian", "it": "Italiano" },
        "category_id": "008a186f-c4cf-40ca-93b9-5f001b4ef646",
        "category_code": "spklang",
    }, {
        "id": "c89a2ca7-36c2-4468-bd94-c760f773af89",
        "name": "Inglese",
        "color": "#ffffff",
        "code": "en",
        "name_translations": { "de": "Englisch", "en": "English", "it": "Inglese" },
        "category_id": "008a186f-c4cf-40ca-93b9-5f001b4ef646",
        "category_code": "spklang",
    },
    {
        "id": "75843bcd-bf30-4bfa-8ea2-b6eee0484d57",
        "name": "Tedesco",
        "color": "#ffffff",
        "code": "de",
        "name_translations": { "de": "Deutsch", "en": "German", "it": "Tedesco" },
        "category_id": "008a186f-c4cf-40ca-93b9-5f001b4ef646",
        "category_code": "spklang",
    }, {
        "id": "96cd448c-c78b-4101-a436-38c777da4787",
        "name": "Francese",
        "color": "#ffffff",
        "code": "fr",
        "name_translations": { "de": "Französisch", "en": "French", "it": "Francese" },
        "category_id": "008a186f-c4cf-40ca-93b9-5f001b4ef646",
        "category_code": "spklang",
    },
    {
        "id": "b1765252-5d59-4a67-8f23-e431106bef12",
        "name": null,
        "color": "#ffffff",
        "code": "bg",
        "name_translations": { "de": "Bulgarisch", "en": "Bulgarian", "it": "Bulgaro" },
        "category_id": "008a186f-c4cf-40ca-93b9-5f001b4ef646",
        "category_code": "spklang",
    },
    {
        "id": "82de2552-6107-4060-b638-81b51107f94b",
        "name": null,
        "color": "#ffffff",
        "code": "da",
        "name_translations": { "de": "Dänisch", "en": "Danish", "it": "Danese" },
        "category_id": "008a186f-c4cf-40ca-93b9-5f001b4ef646",
        "category_code": "spklang",
    },
    {
        "id": "7658c6bc-76a2-4e70-99d5-4f5422d92ae7",
        "name": null,
        "color": "#ffffff",
        "code": "ar",
        "name_translations": { "de": "Arabisch", "en": "Arab", "it": "Arabo" },
        "category_id": "008a186f-c4cf-40ca-93b9-5f001b4ef646",
        "category_code": "spklang",
    },
    {
        "id": "d357db7d-5238-438d-8cdf-6c3a8f9068cd",
        "name": "Russo",
        "color": "#ffffff",
        "code": "ru",
        "name_translations": { "de": "Russisch", "en": "Russian", "it": "Russo" },
        "category_id": "008a186f-c4cf-40ca-93b9-5f001b4ef646",
        "category_code": "spklang",
    },
    {
        "id": "dd02bba2-d0f1-49da-8518-df494762cd51",
        "name": "Spagnolo",
        "color": "#ffffff",
        "code": "es",
        "name_translations": { "de": "Spanisch", "en": "Spanish", "it": "Spagnolo" },
        "category_id": "008a186f-c4cf-40ca-93b9-5f001b4ef646",
        "category_code": "spklang",
    },
    {
        "id": "fc79160a-291f-45aa-83ba-126f31d2ffbf",
        "name": null,
        "color": "#ffffff",
        "code": "zh",
        "name_translations": { "de": "Chinesischen", "en": "Chinese", "it": "Cinese" },
        "category_id": "008a186f-c4cf-40ca-93b9-5f001b4ef646",
        "category_code": "spklang",
    },
    {
        "id": "24ba1ae6-7853-4b1a-91de-50664c66e1bd",
        "name": null,
        "color": "#ffffff",
        "code": "pt",
        "name_translations": { "de": "Portugiesisch", "en": "Portuguese", "it": "Portoghese" },
        "category_id": "008a186f-c4cf-40ca-93b9-5f001b4ef646",
        "category_code": "spklang",
    },
    {
        "id": "6463f755-8662-459a-94dd-4bf2fc368d37",
        "name": "Rumeno",
        "color": "#ffffff",
        "code": "ro",
        "name_translations": { "de": "Rumänische", "en": "Romanian", "it": "Rumeno" },
        "category_id": "008a186f-c4cf-40ca-93b9-5f001b4ef646",
        "category_code": "spklang",
    },
    {
        "id": "fe7aee20-aa8d-458d-9ece-712bbbb4d2f0",
        "name": null,
        "color": "#ffffff",
        "code": "pl",
        "name_translations": { "de": "Polnisch", "en": "Polish", "it": "Polacco" },
        "category_id": "008a186f-c4cf-40ca-93b9-5f001b4ef646",
        "category_code": "spklang",
    }
];


const services = [{
    "id": "b77773f2-6360-48ce-ad5f-056d76669899",
    "name": {
        "nameIt": "Agriturismo",
        "nameEn": "Agriturismo"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Agriturismo.svg"
},
{
    "id": "980a683c-ed6f-4b3d-b780-a9561104dcd1",
    "name": {
        "nameIt": "Bed & Breakfast",
        "nameEn": "Bed & Breakfast"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Bed_&_Breakfast.svg"
},
{
    "id": "ee2b1b52-5a54-4115-ae43-eccbdda7be6a",
    "name": {
        "nameIt": "Scuola di Cucina",
        "nameEn": "Cooking Class"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Scuola_di_cucina.svg"
},
{
    "id": "80968cef-b8ee-4bbd-bc8a-c66fe9de2842",
    "name": {
        "nameIt": "Organizzazione di visite culturali",
        "nameEn": "Organization of cultural visits"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Organizzazione_di_visite_culturali.svg"
},
{
    "id": "790b06a0-0d45-4054-801d-a4104d74d115",
    "name": {
        "nameIt": "Accesso Disabili",
        "nameEn": "Wheelchair access"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Accesso_disabili.svg"
},
{
    "id": "9f45fe99-6c5e-47e5-b574-ce02a489c865",
    "name": {
        "nameIt": "Bistrot / Ristorante",
        "nameEn": "Bistrot / Restaurant"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Bistrot.svg"
},
{
    "id": "4bf03e80-ec90-40e6-852d-08fc1ea8d96a",
    "name": {
        "nameIt": "Palestra",
        "nameEn": "Gym"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Palestra.svg"
},
{
    "id": "74d42985-188b-4840-a0b6-c8336ae8dd16",
    "name": {
        "nameIt": "Autista",
        "nameEn": "Driver"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Autista.svg"
},
{
    "id": "42c0d4a2-e592-43d6-952f-07e6f1798868",
    "name": {
        "nameIt": "Barbecue Elettrico",
        "nameEn": "Electric Barbecue "
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Barbecue_elettrico.svg"
},
{
    "id": "bcb3751f-7a7d-42fe-9091-d2927f53a523",
    "name": {
        "nameIt": "Lavanderia",
        "nameEn": "Laundry"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Lavanderia.svg"
},
{
    "id": "a7e8a822-77aa-413e-a677-64dfaa27c333",
    "name": {
        "nameIt": "Tour in carrozza",
        "nameEn": "Carriage tour"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Tour_in_carrozza.svg"
},
{
    "id": "c1779906-cc79-4c8b-a15f-e27fd5313218",
    "name": {
        "nameIt": "Wi-Fi",
        "nameEn": "Wi-Fi"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Wi-Fi.svg"
},
{
    "id": "685a6a57-8436-40b5-b46b-ff9611042d6b",
    "name": {
        "nameIt": "Fitto barca",
        "nameEn": "Boat renting"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Fitto_barca.svg"
},
{
    "id": "9726ea03-ed14-4fa7-9f66-32ca3c801958",
    "name": {
        "nameIt": "Animali Ammessi",
        "nameEn": "Pets Allowed"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Animali_ammessi.svg"
},
{
    "id": "9100064c-fe1f-4eeb-ac2e-f29d31d94592",
    "name": {
        "nameIt": "Stazione Ricarica Auto Elettriche",
        "nameEn": "Electric Car Charging Station"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Stazione_ricarica_auto_elettriche.svg"
},
{
    "id": "1ad9d0c0-f6bd-4da1-955b-e4d1ae5297b5",
    "name": {
        "nameIt": "Con Pernottamento ",
        "nameEn": "Overnight stay"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Con_pernottamento.svg"
},
{
    "id": "361ee829-e703-44c6-9bf0-03c654faf0b7",
    "name": {
        "nameIt": "Accetta Carte di Credito",
        "nameEn": "Accept Credit Cards"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Accetta_carte_di_credito.svg"
},
{
    "id": "a0df3c3e-1786-41a9-ad60-fc5aa0138b48",
    "name": {
        "nameIt": "Mostra agricola permanente",
        "nameEn": "Permanent agricultural exhibition"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Mostra_agricola_permanente.svg"
},
{
    "id": "c263eff4-26e8-482e-b713-6c224a2fc1a5",
    "name": {
        "nameIt": "Wine Bar",
        "nameEn": "Wine Bar"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Wine_Bar.svg"
},
{
    "id": "a94119c8-fdba-4862-ac42-5baed7a9a7eb",
    "name": {
        "nameIt": "Area panoramica esterna per eventi",
        "nameEn": "External panoramic area for events"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Area_panoramica_esterna_per_eventi.svg"
},
{
    "id": "790843c8-ace6-4f5f-9208-4c9d2ad62c0d",
    "name": {
        "nameIt": "Trekking",
        "nameEn": "Trekking"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Trekking.svg"
},
{
    "id": "3f94942c-b7ba-4745-b37d-84fde35f328a",
    "name": {
        "nameIt": "Giardini/Parco esterni/o",
        "nameEn": "Outdoor gardens / park"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Giardino.svg"
},
{
    "id": "78e81182-4903-48de-93fe-18669495d5e2",
    "name": {
        "nameIt": "Vendita Prodotti Enogastronomici",
        "nameEn": "Sales of food & wine products"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Vendita_prodotti_enogastronomici.svg"
},
{
    "id": "16180d61-c686-4fd0-bb3f-ef881ca4637b",
    "name": {
        "nameIt": "Prestito Biciclette",
        "nameEn": "Bicycle"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Prestito_biciclette.svg"
},
{
    "id": "f4600461-4971-40ea-bc44-faeef592d4d7",
    "name": {
        "nameIt": "Vendita Olio Evo",
        "nameEn": "Evo Oil sales"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Vendita_Olio_Evo.svg"
},
{
    "id": "3624f69e-77ef-4c6d-8b5a-069e7397c65f",
    "name": {
        "nameIt": "Piscina",
        "nameEn": "Swimming pool"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Piscina.svg"
},
{
    "id": "ecb30758-de79-41e6-bff3-effe3b9df366",
    "name": {
        "nameIt": "SPA",
        "nameEn": "SPA"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/SPA.svg"
},
{
    "id": "f1bff2cb-dbd6-4fef-bb52-87428ea07657",
    "name": {
        "nameIt": "Attività Sportive",
        "nameEn": "Sport Activities"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Attivita_sportive.svg"
},
{
    "id": "f02bd504-340b-41d1-bca7-28b655f1dc78",
    "name": {
        "nameIt": "Parcheggio Auto",
        "nameEn": "Parking"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Parcheggio_auto.svg"
},
{
    "id": "e31cc2d2-36ec-4fa6-80e2-79e8c608b13a",
    "name": {
        "nameIt": "Vendita Vino",
        "nameEn": "Wine Sales"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Vendita_Vino.svg"
},
{
    "id": "b911ab85-c9f6-429c-9373-fc8c2e471894",
    "name": {
        "nameIt": "Salone interno per eventi",
        "nameEn": "Internal event hall"
    },
    "category_code": "services",
    "icon": "assets/icons/Servizi_icone/Salone_interno_per_eventi.svg"
}
];
